import AppButton from "../../AppButton";
import { hasLockedRule } from "../utils/masking";

export const CustomQueryDeleteRuleButton = (props: any) => {
  const isLocked = hasLockedRule(props?.ruleOrGroup, props?.context);
  return (
    <AppButton
      variant="danger"
      onClick={(e: any) => props?.handleOnClick(e)}
      title={isLocked ? "Masked condition cannot be removed" : props?.label ?? "Delete"}
      isDisabled={isLocked}
      style={{ minHeight: "32px", height: "32px" }}
      className="remove-rule__btn"
    >
      {props?.label ?? "Delete"}
    </AppButton>
  );
};
